import { render } from "./Test1.vue?vue&type=template&id=32fdae6b"
import script from "./Test1.vue?vue&type=script&lang=js"
export * from "./Test1.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Test1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32fdae6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32fdae6b', __exports__)) {
    api.reload('32fdae6b', __exports__)
  }
  
  module.hot.accept("./Test1.vue?vue&type=template&id=32fdae6b", () => {
    api.rerender('32fdae6b', render)
  })

}


export default __exports__